import React, { ReactNode, memo } from 'react';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import CustomLink from '../CustomLink/CustomLink';
import FiftyFifty from '../FiftyFifty/FiftyFifty';
import ListAndMediaProps from './ListAndMedia.interface';
import Image from '../Image/Image';
import Heading, { HeadingTypes } from '../Heading/Heading';
import SbImage from '../SbImage/SbImage';
import classNames from 'classnames';

const ListAndMedia: React.FC<ListAndMediaProps> = ({
  blok: { list_items },
  blok,
}) => {
  const ConditionalWrapper = (props: {
    url?: string;
    label: string;
    children: ReactNode;
  }): JSX.Element => {
    if (props.url) {
      return (
        <CustomLink
          url={props.url}
          label={props.label}
          className="flex flex-row items-stretch space-x-6 text-sm group bg-stepper/stepper-bg hover:bg-stepper/stepper-active-bg p-6 rounded-[12px] transition-all group"
        >
          {props.children}
        </CustomLink>
      );
    } else {
      return (
        <div className="flex items-start space-x-6 text-sm">
          {props.children}
        </div>
      );
    }
  };

  return (
    <FiftyFifty blok={blok}>
      <ul className="space-y-8">
        {list_items?.length &&
          list_items.map(({ link, heading, body, icon, _uid }) => (
            <li key={_uid}>
              <ConditionalWrapper url={link?.cached_url} label={heading}>
                <div className="min-h-[56px] min-w-[56px] max-h-[56px] max-w-[56px] flex justify-center items-center border rounded-full border-[#009bef] bg-[#E5F4F9]">
                  <div className="w-[32px] h-[32px]">
                    {icon && (
                      <SbImage
                        asset={icon}
                        options={{ width: 32, height: 32, sizes: { base: 64 } }}
                      />
                    )}
                  </div>
                </div>
                <div className="grow">
                  {heading && (
                    <Heading
                      text={heading}
                      headingType={HeadingTypes.h4}
                      className={classNames(
                        'pb-[16px] transition-all !duration-150 group-hover:!text-system/white'
                      )}
                    />
                  )}
                  {body && (
                    <p className="text-text/body-tint text-base group-hover:text-system/white transition-all">
                      {body}
                    </p>
                  )}
                </div>
                {link?.cached_url && (
                  <div className="hidden sm:block">
                    <div className="flex items-center h-full w-full">
                      <div
                        className="bg-no-repeat w-7 h-7 bg-button/icon-bg group-hover:bg-system/white transition-all duration-150"
                        style={{
                          WebkitMaskImage: "url('/svgs/right-arrow.svg')",
                          maskImage: "url('/svgs/right-arrow.svg')",
                        }}
                      />
                    </div>
                  </div>
                )}
              </ConditionalWrapper>
            </li>
          ))}
      </ul>
    </FiftyFifty>
  );
};

export default memo(withBlokWrapper(ListAndMedia));
